/** DB `Setting.name` keys — must match admin save and server. */
export const WHATSAPP_SETTING_SIGNUP = 'whatsappNumberSignup'
export const WHATSAPP_SETTING_DEPOSIT_WITHDRAW = 'whatsappNumberDepositWithdraw'
export const WHATSAPP_SETTING_SUPPORT = 'whatsappNumberSupport'

export const WHATSAPP_SETTINGS_EVENT_REFRESH = 'whatsappNumbersSettingsUpdated'
